import Vue from 'vue'
import { Getter, Action, Mutation } from 'vuex-class'
import { Component, Watch } from 'vue-property-decorator'
import Footer from '@/components/footer/footer'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import Header from '@/components/header/header'
import AsideCart from '@/components/asideCart/asideCart'
import ProductsBtn from '@/components/productsBtn/productsBtn'
import { cityParser } from '@/plugins/city_parser'

@Component({
  components: {
    Header,
    AsideCart,
    Footer,
    ProductCarousel: () => import('@/components/productCarousel/productCarousel'),
    ButtonNumber: () => import('@/components/buttonNumber/buttonNumber'),
    AddCartButton: () => import('@/components/addCartButtom/addCartButtom'),
    modalCar: () => import('@/components/modalCar/modalCar'),
    SkeletonBanner: () => import('@/components/skeletonBanner/skeletonBanner'),
    ModalAddons: () => import('@/components/modalAddons/modalAddons'),
    SkeletonFluid,
    ProductsBtn
  }
})
export default class Product extends Vue {
  @Action action_getCurrentProduct
  @Action action_registerViewProduct;
  @Getter getCurrentProduct
  @Getter getCountry
  @Getter getCity
  @Getter getUser
  @Getter getCartTemporal
  @Mutation IS_SELECT_COUNTRY;
  @Mutation CART_TEMPORAL;

  isShowCar = false
  isOpenAddons = false
  isEditAddons = false
  productQuantity = 1
  isCancelButton = false

  product

  isBtnLoaded = false
  isProductLoaded = false

  async mounted() {
    this.product = (this.getCurrentProduct as any)
    this.IS_SELECT_COUNTRY(true)
    const id = this.$route.params.id
    await this.action_getCurrentProduct({
      idc: this.getCity.id,
      idp:  id
    })
    this.isProductLoaded = true;
    if (Object.keys(this.getUser).length > 0) {
      this.action_registerViewProduct(id)
    }
    this.setPageTitle();
  }

  setPageTitle() {
    if (
      window &&
      window.document &&
      window.document.title &&
      this.getCurrentProduct &&
      this.getCurrentProduct.name
    ) {
      window.document.title = `${this.getCurrentProduct.name} - TodosComemos`;
    }
  }

  @Watch('isBtnLoaded')
  onIsBtnLoaded() {
    this._executeAddBtn();
  }

  get geActiveProdcut() {
    const cart = this.getCartTemporal
    const product = (this.getCurrentProduct as any)
    const index = cart.findIndex((item) => item.product.id === product.id)
    return index !== -1 && product.product_options && product.product_options.length
  }

  get getPrice() {
    const cart = this.getCartTemporal
    const product = (this.getCurrentProduct as any)
    const index = cart.findIndex((item) => item.product.id === product.id)
    const productFilter = cart.filter((item) => item.product.id === product.id)
    // capturamos el precio del producto
    let price = parseFloat(product.price)
    if (index !== -1) {
      // revisamos si el usuario tiene adicionales seleccionado
      if (productFilter.length && productFilter[0].hasOwnProperty('addons')) {
        productFilter[0].addons.map((item) => {
          // validamos si el grupo modificador es multiseleccion o seleccion unica
          // luego sumamos cada addon con el precio del producto
          if (item.is_multiple) {
            item.addons.map((a) => {
              let priceAddon = parseFloat(a.price)
              price = price + priceAddon
            })
          } else {
            let priceAddon = parseFloat(item.addons.price)
            price = price + priceAddon
          }
        })
      }
    }

    return price
  }

  get gerBanners() {
    let banners = this.getCurrentProduct && Object.keys(this.getCurrentProduct).length && this.getCurrentProduct.product_banners
    banners.sort((a, b) => a.ordinal - b.ordinal)
    return banners
  }

  _toggleCard(edit = false) {
    this.isShowCar = !this.isShowCar
  }

  _addToCartReturn() {
    let cart = this.getCartTemporal
    const index = cart.findIndex((item) => item.product.id === this.getCurrentProduct.id)
    const productFilter = cart.filter((item) => item.product.id === this.getCurrentProduct.id)
    let data = {}
    if (index !== -1) {
      data = {
        ...productFilter[0],
        qty: cart[index].qty + this.productQuantity
      }
      cart.splice(index, 1, data)

    } else if (this.productQuantity > 0) {
      const prod = {
        description: this.getCurrentProduct.description,
        discount: this.getCurrentProduct.discount,
        freeze_time: this.getCurrentProduct.freeze_time,
        id: this.getCurrentProduct.id,
        ingredients: this.getCurrentProduct.ingredients,
        instance_currency: this.getCurrentProduct.instance_currency,
        is_activated: this.getCurrentProduct.is_activated,
        name: this.getCurrentProduct.name,
        ordinal: this.getCurrentProduct.ordinal,
        portions: this.getCurrentProduct.portions,
        price: this.getCurrentProduct.price,
        product_banners: this.getCurrentProduct.product_banners,
        product_picture: this.getCurrentProduct.product_picture,
        refrigerated_time: this.getCurrentProduct.refrigerated_time
      }

      data = {
        product: prod,
        qty: this.productQuantity
      }
      cart.push(data)
    }
    this.CART_TEMPORAL(cart)
    const city_id = cityParser(this.getCity.commercial_name)
    this.$nextTick(() => {
      if (window.history.length <= 3) {
        this.$router.push({ name: 'superCategory', params: { city_id: city_id } })
      } else {
        this.$router.go(-1)
      }
    })
  }

  _toggleBtn() {
  }

  _onAddons(edit = false) {
    if (edit) this.isEditAddons = true
    this.isOpenAddons = !this.isOpenAddons
  }

  _onCloseAddons() {
    this.isEditAddons = false
    this.isOpenAddons = false
  }

  onButtonNumberMounted() {
    this.isBtnLoaded = true
  }

  _executeAddBtn() {
    if (this.isBtnLoaded && this.isProductLoaded) {
      const productCart = this.getCartTemporal.find((item) => item.product.id === this.getCurrentProduct.id)
      if (!productCart) {
        this.$nextTick(() => {
          (this.$refs.buttonNumber as any)._add(this.getCurrentProduct)
        })
      }
    }
  }

  _updateQuantity(val) {
    this.productQuantity = val
    this.isCancelButton = this.productQuantity > 0 ? false : true;
  }

  _price(value) {
    let valueReturn: string = this.$currency.format(value, { code: this.getCountry.currency })
    if (this.getCountry.country_code == 'co') {
      let valueReturnSplit: string[] = valueReturn.split(',')
      return valueReturnSplit[0]
    } else {
      return valueReturn
    }
  }

  _discount() {
    let discount = this.getCurrentProduct.promos[this.getCurrentProduct.promos.length - 1]

    switch (discount.promo_type) {
      case 'amount':
        return this.getCurrentProduct.price - discount.promo_amount

      case 'percentage':
        let percent = this.getCurrentProduct.price * (discount.promo_amount / 100)
        return this.getCurrentProduct.price - percent
    }
  }

  onBackButtonPress() {
    this.$router.replace({ name: 'superCategory' });
  }

  @Watch('$route', { deep: true })
  async onRouteChange() {
    if(this.$route.params && this.$route.params.id) {
      this.isProductLoaded = false;
      const productId = this.$route.params.id;
      await this.action_getCurrentProduct({
        idc : this.getCity.id,
        idp: productId
      });
      this.isProductLoaded = true;
      if (Object.keys(this.getUser).length > 0) {
        this.action_registerViewProduct(productId);
      }
    }
  }
}
